<template>
  <section
    class="hero-software"
    id="home"
    aria-labelledby="home-title"
    data-analytics-section="hero"
    data-analytics-section-name="Hero"
  >
    <div class="container_f1">
      <div class="hero-item">
        <div class="hero-content">
          <h1 id="home-title" class="hero-content-title">{{ heading }}</h1>
          <p class="hero-content-subtitle">
            Create the MOGRT in After Effects. Your team changes content in a browser. Your own machine renders the result.
          </p>
          <a href="https://app.modeck.io/login?signup=1" class="btn btn--green" data-analytics-id="hero_start_free">
            Start for free
          </a>
          <a href="#steps" class="btn btn--outline hero-secondary-action" data-analytics-id="hero_how_it_works">
            See how it works
          </a>
        </div>
        <div class="hero-thumb pr-100" aria-hidden="true">
          <lottie :options="defaultOptions" v-on:animCreated="handleAnimation" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Lottie from "./lottie.vue";
import * as animationData from "../assets/splash.json";
import { pageForPath } from "../seo/pages.mjs";
export default {
  name: "HomeHero",
  components: {
    lottie: Lottie,
  },
  data() {
    return {
      heading: pageForPath('/').heading,
      defaultOptions: { animationData: animationData.default },
      animationSpeed: 1,
    };
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim;
      this.anim.play();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/variabls.scss";
@import "../assets/scss/elements/hero-software.scss";

.hero-software {
  overflow: hidden;
  background:
    radial-gradient(circle at 83% 32%, rgba(104, 192, 206, 0.14), transparent 26%),
    linear-gradient(180deg, #ffffff 0%, #fbfcff 100%);
}

.hero-item {
  min-height: 780px;
  height: auto;
  padding: 165px 0 65px;
  box-sizing: border-box;
}

.hero-content {
  width: min(650px, 46vw);
  padding: 0 0 0 clamp(30px, 6vw, 120px);
  box-sizing: content-box;
  align-self: flex-end;
}

.hero-eyebrow {
  margin-bottom: 10px;
  color: #d9317c;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.11em;
  text-transform: uppercase;
}

.hero-content-title {
  max-width: 650px;
  margin-bottom: 22px;
  font-size: clamp(38px, 4.2vw, 50px);
  font-weight: 500;
  letter-spacing: -0.035em;
  line-height: 1.08;
}

.hero-content-subtitle {
  max-width: 620px;
  padding: 0;
  margin-bottom: 32px;
  color: #5a6e8e;
  font-size: 19px;
  font-weight: 400;
  line-height: 1.75;
}

.hero-secondary-action {
  margin-left: 12px;
}

.hero-thumb.pr-100 {
  width: min(890px, 50vw);
  padding-right: clamp(30px, 6vw, 110px);
}

@media (max-width: 1199px) {
  .hero-item {
    min-height: 720px;
    padding: 145px 0 55px;
  }

  .hero-content {
    width: 50%;
    padding-left: 50px;
  }

  .hero-thumb.pr-100 {
    width: 48%;
    padding-right: 35px;
  }
}

@media (max-width: 991px) {
  .hero-item {
    min-height: auto;
    padding: 135px 24px 70px;
    flex-direction: column;
  }

  .hero-content {
    width: min(680px, 100%);
    padding-left: 0;
    margin: 0 auto;
    text-align: center;
  }

  .hero-eyebrow,
  .hero-content-title,
  .hero-content-subtitle {
    margin-left: auto;
    margin-right: auto;
  }

  .hero-thumb.pr-100 {
    width: min(680px, 100%);
    padding: 45px 0 0;
  }
}

@media (max-width: 575px) {
  .hero-item {
    padding: 105px 18px 50px;
  }

  .hero-content-title {
    padding: 0;
    font-size: 38px;
  }

  .hero-content-subtitle {
    padding: 0;
    font-size: 17px;
  }

  .hero-secondary-action {
    margin: 10px 0 0;
  }

  .hero-content .btn {
    display: block;
  }
}
</style>
